module.exports = __webpack_public_path__ + "static/img/icon-timerMenu.2ad47c91.png";